import { createContext } from "react";
import { defaultUserAccountData } from "./utils";
const AccountContext = createContext({
    editMode: {
        details: false,
        shipAddress: false,
        payment: false,
        communication: false,
        billingAddress: false,
        giftCards: false,
    },
    updateEditModeState: () => null,
    userAccount: {
        availablePointBalance: 0,
        pointsLoaded: 0,
        tier: "",
        actionsCompleted: {},
        actionHistory: [],
        slug: "",
        sheerIdVerified: false,
        tierProgress: undefined,
        ...defaultUserAccountData,
    },
    onChangeData: (value, name, objName) => null,
    onChangeCommunicationData: () => null,
    communicationPrefs: {
        email_opt_in: false,
        sms_opt_in: false,
    },
});
export default AccountContext;
